interface TimeObject {
  hour: string;
  minute: string;
  period: 'AM' | 'PM';
}

function convertTo12HourFormatObject(timeString: string): TimeObject {
  let hours: number;
  let minutes: number;
  let period: 'AM' | 'PM';

  const hasAMPM =
    timeString.toUpperCase().includes('AM') ||
    timeString.toUpperCase().includes('PM');

  if (hasAMPM) {
    const [time, periodPart] = timeString.split(' ');
    [hours, minutes] = time.split(':').map(Number);
    period = periodPart.toUpperCase() === 'PM' ? 'PM' : 'AM';
  } else {
    [hours, minutes] = timeString.split(':').map(Number);
    period = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
  }

  return {
    hour: String(hours).padStart(2, '0'),
    minute: String(minutes).padStart(2, '0'),
    period,
  };
}

export default convertTo12HourFormatObject;
